// client/src/views/Sidebar_parts/SidebarBottomBanner.js
import React, { useState } from "react";
import AdSlot from "../../components/AdSlot";

export default function SidebarBottomBanner({
  isEligibleForAds,
  isMobile,
  tipUrl,
  adsBarHeight,
  adsInnerHeight,
  adsGap,
  largeAdsMode,
  ADS_BANNER_W,
  ADS_BANNER_H,
  baseAdTargeting,
  topAdId,
  bottomAdId,
  largeAdId,
  tipBarHeight,
}) {
  const [isCreateCtaHovered, setIsCreateCtaHovered] = useState(false);

  if (isEligibleForAds) {
    return (
      <div
        style={{
          flex: "0 0 auto",
          width: "100%",
          background: "linear-gradient(90deg, #222 90%, #444)",
          padding: isMobile
            ? "7px 8px calc(7px + env(safe-area-inset-bottom)) 8px"
            : "9px 10px 9px 10px",
          textAlign: "center",
          zIndex: 200,
          boxShadow: "0 -2px 14px #0009",
          boxSizing: "border-box",
          height: adsBarHeight,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            height: adsInnerHeight,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: isMobile ? 0 : adsGap,
            boxSizing: "border-box",
          }}
        >
          {isMobile ? (
            <AdSlot
              id={"Map_mobile_sidebar_banner"}
              sizes={[[ADS_BANNER_W, ADS_BANNER_H]]}
              refreshTime={30}
              refreshVisibleOnly={true}
              style={{
                display: "block",
                width: "100%",
                height: ADS_BANNER_H,
                minHeight: ADS_BANNER_H,
              }}
              targeting={{
                ...baseAdTargeting,
                pos: "mobile_bottom",
              }}
            />
          ) : largeAdsMode ? (
            <AdSlot
              id={largeAdId}
              sizes={[[300, 250]]}
              refreshTime={30}
              refreshVisibleOnly={true}
              style={{
                display: "block",
                width: "100%",
                height: 250,
                minHeight: 250,
              }}
              targeting={{
                ...baseAdTargeting,
                pos: "large",
              }}
            />
          ) : (
            <>
              <AdSlot
                id={topAdId}
                sizes={[[ADS_BANNER_W, ADS_BANNER_H]]}
                refreshTime={30}
                refreshVisibleOnly={true}
                style={{
                  display: "block",
                  width: "100%",
                  height: ADS_BANNER_H,
                  minHeight: ADS_BANNER_H,
                }}
                targeting={{
                  ...baseAdTargeting,
                  pos: "top",
                }}
              />

              <AdSlot
                id={bottomAdId}
                sizes={[[ADS_BANNER_W, ADS_BANNER_H]]}
                refreshTime={30}
                refreshVisibleOnly={true}
                style={{
                  display: "block",
                  width: "100%",
                  height: ADS_BANNER_H,
                  minHeight: ADS_BANNER_H,
                }}
                targeting={{
                  ...baseAdTargeting,
                  pos: "bottom",
                }}
              />
            </>
          )}
        </div>
      </div>
    );
  }

  if (tipUrl) {
    return (
      <div
        style={{
          flex: "0 0 auto",
          width: "100%",
          background: "linear-gradient(90deg, #222 90%, #444)",
          padding: isMobile ? "10px 0 calc(8px + env(safe-area-inset-bottom)) 0" : "16px 0 12px 0",
          textAlign: "center",
          zIndex: 200,
          boxShadow: "0 -2px 14px #0009",
          height: tipBarHeight,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
        }}
      >
        <a
          href={tipUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            background: "linear-gradient(90deg, #ffe670 50%, #ffc42d 100%)",
            color: "#1a1500",
            borderRadius: isMobile ? 10 : 12,
            fontWeight: 800,
            fontSize: isMobile ? 14.5 : 16.5,
            padding: isMobile ? "9px 26px" : "11px 36px",
            margin: 0,
            textDecoration: "none",
            boxShadow: "0 1px 14px #ffd70055",
            letterSpacing: isMobile ? "0.7px" : "1px",
            border: "2px solid #a08410",
            transition: "background 0.18s, box-shadow 0.18s",
            maxWidth: "92%",
            boxSizing: "border-box",
            whiteSpace: "nowrap",
          }}
        >
          💸 Tip the Map Creator
        </a>
      </div>
    );
  }

  return (
    <div
      style={{
        flex: "0 0 auto",
        width: "100%",
        background: "linear-gradient(90deg, #222 90%, #444)",
        padding: isMobile ? "10px 0 calc(8px + env(safe-area-inset-bottom)) 0" : "16px 0 12px 0",
        textAlign: "center",
        zIndex: 200,
        boxShadow: "0 -2px 14px #0009",
        height: tipBarHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
      }}
    >
      <a
        href="/?createMap=1"
        onMouseEnter={() => setIsCreateCtaHovered(true)}
        onMouseLeave={() => setIsCreateCtaHovered(false)}
        style={{
          display: "inline-block",
          background: isCreateCtaHovered
            ? "linear-gradient(90deg, #5ff2bf 50%, #2fd89a 100%)"
            : "linear-gradient(90deg, #40dca5 50%, #23be88 100%)",
          color: "#002b1e",
          borderRadius: isMobile ? 10 : 12,
          fontWeight: 800,
          fontSize: isMobile ? 14 : 15.5,
          padding: isMobile ? "9px 18px" : "10px 30px",
          margin: 0,
          textDecoration: "none",
          boxShadow: isCreateCtaHovered ? "0 0 22px #00ffbf88" : "0 1px 14px #00ffbf55",
          letterSpacing: isMobile ? "0.6px" : "0.9px",
          border: "2px solid #0a7755",
          transition: "background 0.18s, box-shadow 0.18s, transform 0.12s",
          transform: isCreateCtaHovered ? "translateY(-1px)" : "translateY(0)",
          maxWidth: "92%",
          boxSizing: "border-box",
        }}
      >
        <div style={{ fontSize: isMobile ? 14.5 : 16.5 }}>➕ Start Your Own Map</div>
        <div
          style={{
            fontSize: isMobile ? 11.5 : 12.5,
            fontWeight: 700,
            marginTop: isMobile ? 1 : 2,
            opacity: 0.95,
          }}
        >
          No login needed • Any game
        </div>
      </a>
    </div>
  );
}
